<template>
  <div class="messageBox sub-main" v-loading="loading">
    <div v-if="flag">
      <div class="messageList">
        <div class="itemBox" v-for="item of messageList" :key="item.noticeId">
          <div class="icon iconfont" :class="{color: item.noticeType === 3}" v-html="item.noticeType === 1 ? '&#xe64a;' : '&#xe647;'"></div>
          <div class="messageTitle">
            <h3 @click="goToDetail(item)" v-if="item.noticeType === 1">{{item.noticeContent}}</h3>
            <h3 @click="goToDetail(item)" v-if="item.noticeType === 3">{{item.noticeTitle}}</h3>
            <span>{{ item.createTime }}</span>
          </div>
        </div>
      </div>
      <el-pagination
        v-if="messageList.length"
        background
        layout="prev, pager, next, jumper"
        :page-size="pageSize"
        :current-page="page"
        @current-change="handleCurrentChange"
        :total="total">
      </el-pagination>
    </div>
    <div class="nothing" v-else>
      <img src="../../../../static/image/noorder@2x.png" alt="">
      <p class="fs20 font-color-999">你还没有消息～</p>
      <router-link to="/">
          <el-button>去首页看看</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import {listSearchMixin} from '@/config/mixin'
import { mapMutations } from 'vuex'
export default {
  name: 'message',
  mixins: [listSearchMixin],
  data () {
    return {
      messageList: [],
      page: 1,
      pageSize: 10,
      total: 1,
      flag: true,
      loading: false
    }
  },
  mounted () {
    this.getAll()
    this.getUserInfo()
  },
  methods: {
    ...mapMutations({
      setUserInfo: 'SET_USERINFO'
    }),
    // 获取消息列表
    getAll () {
      let self = this
      // const rLoading = this.openLoading()
      self.loading = true
      let params = {
          url: api.noticeGetAll + `?page=${this.page}&pageSize=${this.pageSize}`,
          method: 'GET',
          data: {}
        }
        self.sendReq(params, (res) => {
          if (res.code === '200') {
            this.messageList = res.data.list
            this.total = res.data.total
            if (res.data.list.length) {
              this.flag = true
            } else {
              this.flag = false
            }
            // rLoading.close()
            self.loading = false
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    // 获取用户信息
    getUserInfo () {
      let params = {
        url: api.getUser,
        method: 'GET'
      }
      this.sendReq(params, (res) => {
        if (res.code === '200') {
          this.setUserInfo(res.data)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    // 翻页
    handleCurrentChange (val) {
      this.page = val
      this.getAll()
    },
    // 查看详情
    goToDetail (item) {
      if (item.noticeType === 1) {
        if (item.jump === 0) {
          this.$router.push({
            path: '/notificationDetails',
            query: {
              id: item.noticeId
            }
          })
        } else if (item.jump === 1) {
          this.$router.push({
            path: '/notificationDetails',
            query: {
              id: item.noticeId
            }
          })
        } else if (item.jump === 2) {
          this.$router.push({
            path: '/orderDetail',
            query: {
              orderId: item.only,
              noticeId: item.noticeId
            }
          })
        }
      } else if (item.noticeType === 3) {
        this.$router.push({
          path: '/notificationDetails',
          query: {
            id: item.noticeId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.messageBox {
  border: 1px solid #E5E5E5;
  padding: 30px;
  .messageList {
    .itemBox {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E5E5E5;
      margin-bottom: 30px;
      padding-bottom: 20px;
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #348bfa;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        font-size: 26px;
        margin-right: 30px;
      }
      .color {
        background: #f75c61;
      }
      .messageTitle {
        h3 {
          color: #333333;
          font-size: 14px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        span {
          color: #666666;
          font-size: 12px;
        }
      }
    }
  }
}
.sub-main{
  min-height: 400px;
}
.nothing{
  width: 100%;
  text-align: center;
  min-height: 400px;
  p{
      margin-bottom: 20px;
  }
  .el-button{
      background-color: #FF7800;
      color: #FFFFFF;
      font-weight: normal;
      border-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/messageCenter/message.vue